{
  "openSeaListNFTMessage": {
    "types": {
      "EIP712Domain": [
        {
          "name": "name",
          "type": "string"
        },
        {
          "name": "version",
          "type": "string"
        },
        {
          "name": "chainId",
          "type": "uint256"
        },
        {
          "name": "verifyingContract",
          "type": "address"
        }
      ],
      "OrderComponents": [
        {
          "name": "offerer",
          "type": "address"
        },
        {
          "name": "zone",
          "type": "address"
        },
        {
          "name": "offer",
          "type": "OfferItem[]"
        },
        {
          "name": "consideration",
          "type": "ConsiderationItem[]"
        },
        {
          "name": "orderType",
          "type": "uint8"
        },
        {
          "name": "startTime",
          "type": "uint256"
        },
        {
          "name": "endTime",
          "type": "uint256"
        },
        {
          "name": "zoneHash",
          "type": "bytes32"
        },
        {
          "name": "salt",
          "type": "uint256"
        },
        {
          "name": "conduitKey",
          "type": "bytes32"
        },
        {
          "name": "counter",
          "type": "uint256"
        }
      ],
      "OfferItem": [
        {
          "name": "itemType",
          "type": "uint8"
        },
        {
          "name": "token",
          "type": "address"
        },
        {
          "name": "identifierOrCriteria",
          "type": "uint256"
        },
        {
          "name": "startAmount",
          "type": "uint256"
        },
        {
          "name": "endAmount",
          "type": "uint256"
        }
      ],
      "ConsiderationItem": [
        {
          "name": "itemType",
          "type": "uint8"
        },
        {
          "name": "token",
          "type": "address"
        },
        {
          "name": "identifierOrCriteria",
          "type": "uint256"
        },
        {
          "name": "startAmount",
          "type": "uint256"
        },
        {
          "name": "endAmount",
          "type": "uint256"
        },
        {
          "name": "recipient",
          "type": "address"
        }
      ]
    },
    "primaryType": "OrderComponents",
    "domain": {
      "name": "Seaport",
      "version": "1.5",
      "chainId": 137,
      "verifyingContract": "0x00000000000000ADc04C56Bf30aC9d3c0aAF14dC"
    },
    "message": {
      "offerer": "0x8c9Ed98b7C3961D22Cc871356C7b73d194608817",
      "offer": [
        {
          "itemType": "2",
          "token": "0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f",
          "identifierOrCriteria": "64560424590441301826453812164224751707642265079650986418901366599236941237984",
          "startAmount": "1",
          "endAmount": "1"
        }
      ],
      "consideration": [
        {
          "itemType": "1",
          "token": "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
          "identifierOrCriteria": "0",
          "startAmount": "194707500000000000",
          "endAmount": "194707500000000000",
          "recipient": "0x8c9Ed98b7C3961D22Cc871356C7b73d194608817"
        },
        {
          "itemType": "1",
          "token": "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
          "identifierOrCriteria": "0",
          "startAmount": "4992500000000000",
          "endAmount": "4992500000000000",
          "recipient": "0x0000a26b00c1F0DF003000390027140000fAa719"
        }
      ],
      "startTime": "1696393777",
      "endTime": "1699072168",
      "orderType": 0,
      "zone": "0x0000000000000000000000000000000000000000",
      "zoneHash": "0x0000000000000000000000000000000000000000000000000000000000000000",
      "salt": "24446860302761739304752683030156737591518664810215442929815805592127532436551",
      "conduitKey": "0x0000007b02230091a7ed01230072f7006a004d60a8d4e71d599b8104250f0000",
      "totalOriginalConsiderationItems": "2",
      "counter": "0"
    }
  }
}
